import gql from "graphql-tag";

export const TOGGLE_CATEGORY = gql`
  mutation toggleCategory($categoryId: String!, $enable: Boolean!) {
    toggleCategory(categoryId: $categoryId, enable: $enable)
  }
`;
